<template>
	<div
		class="relative bg-surface dark:bg-dark-700 rounded-card p-5 shadow-card border border-primary-100 dark:border-dark-600 hover:shadow-card-hover hover:-translate-y-0.5 transition-all duration-200 overflow-hidden group">
		<!-- Decorative orb -->
		<div
			class="absolute -top-6 -right-6 w-20 h-20 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-primary-400/8 dark:bg-primary-400/10" />

		<!-- Title -->
		<div class="flex items-center justify-between mb-4">
			<p
				class="text-[12px] font-bold uppercase tracking-widest text-muted dark:text-muted-light">
				{{ title }}
			</p>
			<slot name="header-icon">
				<!-- Default icon slot — teal dot indicator -->
				<span class="w-2 h-2 rounded-full bg-primary-400 opacity-60" />
			</slot>
		</div>

		<!-- Value -->
		<div v-if="isLoading" class="animate-pulse">
			<div class="h-9 w-24 bg-primary-100 dark:bg-dark-600 rounded-lg mb-2" />
			<div class="h-3 w-16 bg-primary-50 dark:bg-dark-500 rounded" />
		</div>

		<div v-else>
			<div
				class="font-display text-3xl font-extrabold tracking-tight leading-none mb-1 text-dark-700 dark:text-white">
				{{ value }}
			</div>
			<div
				v-if="unit"
				class="text-[12px] font-medium text-muted dark:text-muted-light mt-1">
				{{ unit }}
			</div>
		</div>

		<!-- Trend -->
		<div v-if="trend !== null" class="flex items-center gap-1.5 mt-3">
			<span
				class="inline-flex items-center gap-1 text-[11px] font-bold rounded-full px-2 py-0.5"
				:class="
					trend >= 0
						? 'bg-primary-50 text-primary-600 dark:bg-primary-400/15 dark:text-primary-300'
						: 'bg-red-50 text-red-500 dark:bg-red-950/30 dark:text-red-400'
				">
				<svg
					class="w-3 h-3"
					fill="none"
					stroke="currentColor"
					viewBox="0 0 24 24">
					<path
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="3"
						:d="trend >= 0 ? 'M5 15l7-7 7 7' : 'M19 9l-7 7-7-7'" />
				</svg>
				{{ Math.abs(trend) }}%
			</span>
			<span class="text-[11px] text-muted dark:text-muted-light">{{
				trendText
			}}</span>
		</div>

		<slot />
	</div>
</template>

<script>
export default {
	name: "InfoCard",
	props: {
		value: { type: [Number, String], default: 0 },
		title: { type: String, required: true },
		unit: { type: String, default: "" },
		trend: { type: Number, default: null },
		trendText: { type: String, default: "" },
		isLoading: { type: Boolean, default: false },
	},
	computed: {
		trendClass() {
			if (this.trend === null) return "";
			return this.trend >= 0
				? "text-primary-600 dark:text-primary-300"
				: "text-red-500 dark:text-red-400";
		},
	},
};
</script>
